<template>
  <div
    :class="[
      //isFullScreen ? 'full-screen' : 'half-screen',
      `screen-${numberSize.split('%')[0]}`,
      'docInteract',
      'history-action',
    ]"
  >
    <div>
      <div class="panel-header flex-row  flex__between has-border__bottom">
        <p class="title font-weight__bold">Lịch sử</p>
        <div class="btn__action">
          <!-- <i class="fal fa-expand item clickable" @click="changeView"></i> -->
          <el-select
            class="none__border select__size"
            placeholder="chọn size"
            size="small"
            v-model="numberSize"
          >
            <el-option
              v-for="item in listSize"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
          <i
            class="fal fa-times item clickable"
            @click="$emit('closeHistory')"
          ></i>
        </div>
      </div>

      <VuePerfectScrollbar
        class="scroll-history"
        :settings="perfectScrollbarSetting"
      >
        <div :class="['panel-body', 'list__action']">
          <div
            v-for="action in histories"
            :key="action.id"
            class="list__action__item"
          >
            <template
              v-if="
                action.actionName === ACTION_LOG_ACTION_NAME.BANHANH_TOI ||
                  action.actionName === ACTION_LOG_ACTION_NAME.BANHANHV2 ||
                  action.actionName ===
                    ACTION_LOG_ACTION_NAME.UPDATE_INCOMING_DOC ||
                  action.actionName === ACTION_LOG_ACTION_NAME.CHOYKIEN ||
                  action.actionName ===
                    ACTION_LOG_ACTION_NAME.HE_THONG_BAN_HANH ||
                  action.actionName ===
                    ACTION_LOG_ACTION_NAME.GUI_YEU_CAU_THUHOI_BANHANH
              "
            >
              <div>
                <div class="avatar-fake margin-right-10 flex-row flex__center">
                  <span>{{ buildShortName(action.creatorName) }}</span>
                </div>
              </div>
              <history-banhanhtoi
                v-if="
                  action.actionName === ACTION_LOG_ACTION_NAME.BANHANH_TOI ||
                    action.actionName === ACTION_LOG_ACTION_NAME.BANHANHV2
                "
                :action="action"
              ></history-banhanhtoi>
              <history-vbden-update
                v-else-if="
                  action.actionName ===
                    ACTION_LOG_ACTION_NAME.UPDATE_INCOMING_DOC
                "
                :action="action"
              ></history-vbden-update>
              <history-cho-y-kien
                v-else-if="
                  action.actionName === ACTION_LOG_ACTION_NAME.CHOYKIEN
                "
                :action="action"
              ></history-cho-y-kien>
              <history-status-tltvb
                v-if="
                  action.actionName ===
                    ACTION_LOG_ACTION_NAME.HE_THONG_BAN_HANH ||
                    action.actionName ===
                      ACTION_LOG_ACTION_NAME.GUI_YEU_CAU_THUHOI_BANHANH
                "
                :action="action"
              ></history-status-tltvb>
            </template>
            <template v-else>
              <div>
                <div class="avatar-fake margin-right-10 flex-row flex__center">
                  <span>{{ buildShortName(action.creatorName) }}</span>
                </div>
              </div>
              <div class="list__action__item--content">
                <div class="flex-row flex__between">
                  <p class="name margin-0">
                    {{ action.creatorName }}
                  </p>
                  <div class="time font-size__small">
                    <i class="fal fa-clock"></i>
                    {{ action.createTime | convertToLabelFilter }}
                  </div>
                </div>
                <div>
                  <p
                    v-if="action.dataType === 'actionLog'"
                    :class="[
                      'action-type flex-row flex__left inline-flex',
                      classColorByActionName(action.actionName)
                    ]"
                  >
                    <i
                      :class="[
                        'font-size__small',
                        classIconByActionName(action.actionName)
                      ]"
                    ></i>
                    <span class="font-size__small no_wrap">
                      &nbsp;{{ action.actionNameLabel }}
                    </span>

                    <!-- <el-tooltip
                      v-if="action.dataJson && action.dataJson.receiverName"
                      :content="
                        action.dataJson.receiverName +
                          ' - ' +
                          action.dataJson.roleReceiverName
                      "
                      placement="top"
                    >
                      <span
                        v-if="action.actionName == 'chuyenXuLi'"
                        class="inline-flex flex-row flex__left clickable"
                      >
                        <span class="tt-1 margin-0 padding-0">
                          &nbsp;{{ action.dataJson.receiverName || "" }}
                        </span>
                      </span>
                    </el-tooltip> -->
                  </p>

                  <!-- diff: data receiverName or deptName (roleName) -->
                  <popoverWord
                    v-for="(item, $index) in buildNameReceivers(action).split(
                      ' '
                    )"
                    :key="$index"
                    :categoryVBan="'doc-in'"
                    :action="action"
                    :word="item"
                    :actionName="action.actionName"
                  />
                  <!-- same: va rest number don vi ( nguoi ) khac -->
                  <popoverWord
                    v-for="item in buildWordTemplate(action)"
                    :key="item"
                    :categoryVBan="'doc-in'"
                    :action="action"
                    :word="item"
                    :actionName="action.actionName"
                  />

                  <!--coment-->
                  <div
                    v-if="
                      action.dataType === 'actionLog' && action.data.comment
                    "
                    class="content__message--text content__message--item"
                  >
                    <el-input
                      type="textarea"
                      resize="none"
                      ref="inputComment"
                      autosize
                      v-model.trim="action.data.comment"
                      disabled
                      class="input-display__comment style-fullWidth input-none__border bg__transparent"
                    ></el-input>
                  </div>

                  <div
                    v-if="action.dataType === 'comment'"
                    class="content__message--text content__message--item"
                  >
                    <el-popover
                      v-if="action.toUsers && action.toUsers.length"
                      placement="top-start"
                      width="400"
                      trigger="click"
                      title="Danh sách: "
                    >
                      <div
                        v-for="(item, index) in action.toUsers"
                        :key="item.id"
                      >
                        <p class="select-signer">
                          {{ index + 1 }}.
                          <span>
                            {{ item.toFullName }}
                            <em class="font-weight__bold font-size__small"
                            >({{
                                item.toPositionName + " - " + item.toDeptName
                              }})</em
                            >
                          </span>
                        </p>
                      </div>

                      <span slot="reference">
                        <span class="highlight--name clickable tt-1">
                          @{{ action.toUsers[0].toFullName }}
                          <span
                            v-if="action.toUsers && action.toUsers.length > 1"
                          >và {{ action.toUsers.length - 1 }} người khác
                          </span>
                        </span>
                      </span>
                    </el-popover>

                    <el-input
                      v-if="action.data.content"
                      type="textarea"
                      resize="none"
                      ref="inputComment"
                      autosize
                      v-model.trim="action.data.content"
                      disabled
                      class="input-display__comment style-fullWidth input-none__border bg__transparent"
                    ></el-input>
                  </div>

                  <action-log-attachments
                    v-if="action.attachments && action.attachments.length"
                    :action="action"
                  >
                  </action-log-attachments>
                </div>
              </div>
            </template>
          </div>
        </div>
      </VuePerfectScrollbar>

      <div id="detail-footer" class="panel-footer" v-if="isEnableComment">
        <div ref="commentArea" :class="['active', 'input-comment']">
          <!-- toUsers -->
          <div
            ref="toUsersArea"
            :class="[
              !isActiveToUsers ? 'fixHeightReceiver' : '',
              'toReceiver',
              'flex-row',
              'flex__between'
            ]"
          >
            <el-select
              ref="toUserSelectDropdown"
              v-show="isActiveToUsers"
              :class="['input-none__border', 'selectListReceiver']"
              v-model="toUserIds"
              placeholder="Chọn người nhận"
              size="medium"
              multiple
              filterable
              clearable
              @visible-change="toUserSelectDropdownVisibleChange"
            >
              <el-option
                v-for="item in toUsers"
                :key="item.id"
                :label="item.fullName"
                :value="item.id"
              >
                <p class="select-signer">
                  <span>
                    {{ item.fullName }}
                    <em class=""
                    >({{ item.positionName + " - " + item.deptName }})</em
                    >
                  </span>
                </p>
              </el-option>
            </el-select>

            <div
              class="display-represent clickable"
              v-show="!isActiveToUsers"
              @click="isActiveToUsers = true"
            >
              <p
                class="margin-0"
                v-if="selectedToUsers && selectedToUsers.length"
              >
                <span>
                  <strong>{{ selectedToUsers[0].fullName }}&nbsp;</strong>
                </span>
                <span v-show="selectedToUsers.length > 1"
                >và {{ selectedToUsers.length - 1 }} người khác..</span
                >
              </p>
              <span
                v-if="!selectedToUsers || !selectedToUsers.length"
                class="placeholder-fake flex-row flex__left"
              >Người nhận</span
              >
            </div>
            <i class="color__silver fas fa-user-circle"></i>
          </div>
          <!-- toUsers:end -->
          <!-- commentInput: -->
          <div>
            <transition name="el-fade-in-linear">
              <el-input
                type="textarea"
                resize="none"
                ref="inputComment"
                :rows="3"
                placeholder="Nội dung bình luận"
                v-model="content"
                class="text-input-comment"
              ></el-input>
            </transition>
          </div>
          <!-- commentInput:end -->
          <!-- commentAttachment: -->
          <div class="action-comment flex-row flex__between">
            <div class="action-file">
              <el-upload
                ref="fileDialog"
                :action="uploadAttachmentURL"
                :headers="uploadAttachmentHeaders"
                :on-success="
                  response =>
                    onUploadSuccess(response).then(response =>
                      uploadAttachmentSuccess(response)
                    )
                "
                :data="uploadAttachmentAdditionalData()"
                :show-file-list="false"
                :before-upload="
                  file => validateUploadFile(file, { acceptFileTypes: ['*'] })
                "
                :on-error="onUploadError"
                v-loading="isUploading"
              >
                <i class="fal fa-paperclip icon-action-comment clickable"></i>
              </el-upload>
            </div>
            <div
              :class="['clickable', 'btn-send-comment', 'font-weight__bold', { 'button-disabled': isSubmitting }]"
              @click="insertComment"
            >
              GỬI
            </div>
          </div>
        </div>
        <transition name="slide">
          <div
            v-if="vbAttachments"
            class="group-info el-upload-list el-upload-list--text"
          >
            <div
              v-for="vbAttachment in vbAttachments"
              :key="vbAttachment.id"
              class="flex-row flex__between file-item el-upload-list__item is-success"
            >
              <div class="flex-row flex__left">
                <a
                  v-openInNewTab
                  :href="
                    getToken(vbAttachment.id)
                      | buildAttachmentURL({
                        type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                      })
                  "
                  class="link-file"
                >
                  <fileTypeImage
                    :fileExtention="vbAttachment.fileExtention"
                    :customClass="'icon-mini'"
                  />
                  <span class="link-file clickable font-size__small">{{
                    vbAttachment.fileName
                  }}</span>
                </a>
              </div>
              &nbsp;
              <label class="el-upload-list__item-status-label">
                <i class="el-icon-upload-success el-icon-circle-check"></i>
              </label>
              <i
                class="el-icon-close el-tooltip item clickable font-size__small color__red"
                @click="removeVbAttachment(vbAttachment)"
              ></i>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import constants from "../../constants";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import convertToLabelFilter from "../../filters/convertToLabelFilter.js";
import dateFormatter from "../../filters/dateFormatter";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import actionLogService from "../../services/actionLogService";
import attachmentService from "../../services/attachmentService";
import h from "../../services/h";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import utils from "../../services/utils";
import vbCommentService from "../../services/vbCommentService";
import vbCommentToUserViewService from "../../services/vbCommentToUserViewService.js";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import ActionLogAttachments from "./actionLogAttachments";
import HistoryBanhanhtoi from "./history-banhanhtoi";
import HistoryChoYKien from "./history-cho-y-kien";
import HistoryStatusTltvb from "./history-status-tltvb";
import HistoryVbdenUpdate from "./history-vbden-update";
import uploadFileMixin from "./uploadFileMixin";

  export default {
    name: "history-docin",
    mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
    props: [
      "vbIncomingDocId",
      "mainVbIncomingDocId",
      "subDocId",
      "isEnableComment"
    ],
    components: {
      HistoryChoYKien,
      HistoryStatusTltvb,
      HistoryVbdenUpdate,
      HistoryBanhanhtoi,
      ActionLogAttachments,
      fileTypeImage: () => import("../common/FileTypeImage"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
      popoverWord: () => import("../common/popoverWord")
    },
    filters: {
      dateFormatter,
      convertToLabelFilter,
      buildAttachmentURL
    },

    watch: {
      // $route() {
      //   this.loadData();
      //   this.loadToUsers();
      // },

      vbIncomingDocId() {
        this.loadData();
      },

      mainVbIncomingDocId() {
        this.loadToUsers();
      },

      // isFullScreen() {
      //   return this.isFullScreen;
      // },

      isToUsersFocused(newValue) {
        this.isActiveToUsers = newValue || this.isToUserSelectDropdownVisible;
      },

      isToUserSelectDropdownVisible() {
        this.isActiveToUsers =
          this.isToUsersFocused || this.isToUserSelectDropdownVisible;
      },

      isActiveToUsers(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            this.$refs.toUserSelectDropdown.focus();
          });
        }
      },

      toUserIds(newValue) {
        this.selectedToUsers = h.collect(newValue, toUserId => {
          return h.find(this.toUsers, toUser => toUser.id === toUserId);
        });
      },
    },
    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
      // userDeptRole() {
      //   return this.$store.getters.userDeptRole;
      // }
    },

    data() {
      return {
        DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
        ACTION_LOG_ACTION_NAME: constants.ACTION_LOG_ACTION_NAME,
        vbAttachment: {},
        isFullScreen: false,
        form: {
          comment: "",
          listReceiver: []
        },
        histories: [],
        toUserIds: [],
        toUsers: [],
        selectedToUsers: [],
        content: null,
        commentToUsers: [],
        actionLogs: [],
        comments: [],
        isToUsersFocused: false,
        isActiveToUsers: false,
        isToUserSelectDropdownVisible: false,
        vbAttachments: [],
        commentVbAttachments: [],
        userDeptRole: null,


        numberSize: "30%",
        listSize: ["30%", "50%", "70%", "100%"],
        isSubmitting: false,
      };
    },

    created() {
      this.loadUserDeptRole()
        .then(() => this.loadData())
        .then(() => this.loadToUsers());
    },

    methods: {
      loadUserDeptRole() {
        return userDeptRoleViewService
          .findById(this.userDeptRoleId)
          .then(response => (this.userDeptRole = response.data));
      },

      getProcessTypeName(processType) {
        switch (processType) {
          case constants.PROCESS_TYPE.CHUTRI:
            return "(Chủ trì)";
          case constants.PROCESS_TYPE.PHOIHOP:
            return "(Phối hợp)";
          case constants.PROCESS_TYPE.NHANDEBIET:
            return "(Nhận để biết)";
          default:
            return "";
        }
      },

      buildWordTemplate: function (action) {
        let templateWord = [];
        if (
          action.dataType === "actionLog" &&
          action.dataJson &&
          action.dataJson.length > 1
        ) {
          if (
            action.actionName === "chuyenXuLiDonVi" ||
            action.actionName === "banHanh"
          ) {
            templateWord = [
              "và",
              (action.dataJson.length - 1).toString(),
              "đơn",
              "vị",
              "khác"
            ];
          } else {
            templateWord = [
              "và",
              (action.dataJson.length - 1).toString(),
              "người",
              "khác"
            ];
          }
        } else {
          templateWord = [];
        }
        return templateWord;
      },

      buildNameReceivers(action) {
        if (
          action.actionName &&
          action.dataType === "actionLog" &&
          action.dataJson
        ) {
          // if response array people
          if (action.dataJson.length) {
            switch (action.actionName) {
              case "chuyenXuLi":
                return (
                  action.dataJson[0].receiverName +
                  " " +
                  this.getProcessTypeName(action.dataJson[0].processType)
                );
              case "chuyenXuLiDonVi":
                return (
                  (action.dataJson[0].toDeptName ||
                    action.dataJson[0].deptReceiverName) +
                  " " +
                  this.getProcessTypeName(action.dataJson[0].processType)
                );
              case "banHanh":
                return (
                  (action.dataJson[0].deptName ||
                    action.dataJson[0].deptReceiverName) +
                  " " +
                  this.getProcessTypeName(action.dataJson[0].processType)
                );
              case "thuHoi":
                return (
                  action.dataJson[0].receiverName ||
                  action.dataJson[0].deptReceiverName
                );
              default:
                return "";
            }
          } else {
            // if dataJson is object and actionName is chuyenXuLi
            if (action.actionName === "chuyenXuLi")
              return action.dataJson.receiverName || "";
          }
        }
        return "";
      },

      removeVbAttachment(vbAttachment) {
        this.vbAttachments.splice(this.vbAttachments.indexOf(vbAttachment), 1);
      },

      uploadAttachmentAdditionalData() {
        return {objectType: constants.ATTACHMENT_OBJECT_TYPE.COMMENT};
      },

      uploadAttachmentSuccess(vbAttachment) {
        this.vbAttachments.push(vbAttachment);
      },

      loadToUsers() {
        return userDeptRoleViewService
          .findAllByVbIncomingDoc(this.mainVbIncomingDocId)
          .then(response => (this.toUsers = response.data));
      },

      loadData() {
        return this.loadActionLogs()
          .then(() => this.loadComments())
          .then(() => this.loadCommentToUsers(this.comments))
          .then(commentToUsers => (this.commentToUsers = commentToUsers))
          .then(() => this.loadCommentVbAttachments(this.comments))
          .then(vbAttachments => {
            this.commentVbAttachments = vbAttachments;
            this.mixToHistories();
          });
      },

      loadCommentVbAttachments(comments) {
        let commentIds = h.collect(comments, comment => comment.id);
        return commentIds && commentIds.length
          ? attachmentService
            .findAllByComments(commentIds, {
              sort: "createTime,desc",
              page: 0,
              size: 1000
            })
            .then(response => response.data)
          : new Promise(resolve => resolve([]));
      },

      loadCommentToUsers(comments) {
        let commentIds = h.collect(comments, comment => comment.id);
        return commentIds && commentIds.length
          ? vbCommentToUserViewService
            .findAll(
              null,
              {sort: "createTime,desc", page: 0, size: 1000},
              commentIds
            )
            .then(response => response.data)
          : new Promise(resolve => resolve([]));
      },

      loadComments() {
        return vbCommentService
          .findAllBySenderIdOrReceiverId(
            this.vbIncomingDocId,
            constants.COMMENT_OBJECT_TYPE.VB_DEN,
            {sort: "createTime,desc", page: 0, size: 1000}
          )
          .then(response => (this.comments = response.data));
      },

      loadActionLogs() {
        // console.log(this.userDeptRole.roleCode);
        // if (this.userDeptRole.roleCode === "vanthu")
        return actionLogService
          .findAllByVbIncomingDoc(this.vbIncomingDocId, this.subDocId, {
            sort: "createTime,desc",
            page: 0,
            size: 1000
          })
          .then(response => (this.actionLogs = response.data));
        // else
        //   return actionLogService
        //     .findAllAccessible(this.vbDocProcessId, {
        //       sort: "createTime,desc",
        //       page: 0,
        //       size: 1000
        //     })
        //     .then(response => (this.actionLogs = response.data));
      },

      changeView() {
        this.isFullScreen = !this.isFullScreen;
      },

      insertComment() {
        if (this.isSubmitting)  {
          this.$message({
            message: "Đang gửi bình luận, vui lòng đợi...",
            type: "info",
          });
          return;
        }

        /**
         * validate comment;
         */
        if (!this.content || !this.content.trim()) {
          this.$message({
            message: "Nội dung bình luận chưa được nhập",
            type: "error"
          });
          return;
        }

        if (!this.selectedToUsers || !this.selectedToUsers.length) {
          this.$message({
            message: "Chưa có người nhận được chọn",
            type: "error"
          });
          return;
        }

        this.isSubmitting = true;
        let vbCommentToUserForms = h.collect(this.selectedToUsers, item => {
          return {
            userId: item.userId,
            deptId: item.deptId,
            roleId: item.roleId,
            positionId: item.positionId,
            userDeptRoleId: item.id
          };
        });
        let attachmentIds = h.collect(this.vbAttachments, item => item.id);

        vbCommentService
          .insert({
            objectId: this.vbIncomingDocId,
            objectType: constants.COMMENT_OBJECT_TYPE.VB_DEN,
            content: this.content,
            vbCommentToUserForms: vbCommentToUserForms,
            attachmentIds: attachmentIds
          })
          .then(response => {
            let comment = response.data;

            /**
             * reset lại form nhập comment;
             */
            this.isActiveToUsers = false;
            this.content = "";
            this.toUserIds = [];
            this.vbAttachments = [];
            this.isSubmitting = false;

            this.comments.push(comment);
            this.loadCommentToUsers([comment]).then(commentToUsers => {
              this.loadCommentVbAttachments([comment]).then(vbAttachments => {
                /**
                 * binding lại danh sách lịch sử, không query lại toàn bộ ảnh hưởng tới performance;
                 */
                this.commentToUsers.push(...commentToUsers);
                this.commentVbAttachments.push(...vbAttachments);
                this.histories.splice(
                  0,
                  0,
                  this.convertCommentToHistory(comment)
                );
              });
            });
          })
          .catch(error => this.commonHandleRequestError(error));
      },

      toUserSelectDropdownVisibleChange(event) {
        this.isToUserSelectDropdownVisible = event;
      },

      buildShortName(fullName) {
        return utils.buildShortName(fullName);
      },

      buildActionLabel(history) {
        if (history.dataType == "actionLog") {
          switch (history.actionName) {
            case constants.ACTION_LOG_ACTION_NAME.INSERT:
              return "Tạo mới";
            case constants.ACTION_LOG_ACTION_NAME.UPDATE:
              return "Cập nhật";
            case constants.ACTION_LOG_ACTION_NAME.UPDATE_INCOMING_DOC:
              return "Sửa sai";
            case constants.ACTION_LOG_ACTION_NAME.CHUYENXULI:
              return "Chuyển xử lý đến";
            case constants.ACTION_LOG_ACTION_NAME.CHOBANHANH:
              return "Duyệt ban hành";
            case constants.ACTION_LOG_ACTION_NAME.TUCHOI:
              return "Từ chối";
            case constants.ACTION_LOG_ACTION_NAME.TUCHOITIEPNHAN:
              return "Từ chối tiếp nhận";
            case constants.ACTION_LOG_ACTION_NAME.BANHANH:
              return "Ban hành văn bản đến";
            case constants.ACTION_LOG_ACTION_NAME.KETTHUC:
              return "Kết thúc";
            case constants.ACTION_LOG_ACTION_NAME.THUHOI:
              return "Thu hồi văn bản từ";
            case constants.ACTION_LOG_ACTION_NAME.CHUYENXULI_DONVI:
              return "Chuyển xử lý đến";
            case constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI:
              return "Từ chối";
            default:
              return history.actionName;
          }
        } else {
          return "";
        }
      },

      loadCommentAttachment_(item) {
        item.attachments = h.findAll(
          this.commentVbAttachments,
          vbAttachment => vbAttachment.objectId === item.data.id
        );
      },

      loadCommentToUsers_(item) {
        item.toUsers = h.findAll(
          this.commentToUsers,
          commentToUser => commentToUser.commentId === item.data.id
        );
      },

      convertCommentToHistory(item) {
        var history = {
          actionName: item.actionName,
          creatorName: item.fromFullName || item.fromUserName,
          creatorId: item.fromUserId,
          createTime: item.createTime,
          dataType: "comment",
          data: item
        };

        history.actionNameLabel = this.buildActionLabel(history);

        this.loadCommentAttachment_(history);
        this.loadCommentToUsers_(history);

        return history;
      },

      mixToHistories() {
        var histories = (this.histories = []);

        h.each(this.actionLogs, item => {
          var history = {
            actionName: item.actionName,
            creatorName: item.creatorName,
            creatorId: item.creatorId,
            createTime: item.createTime,
            dataType: "actionLog",
            data: item,
            dataJson: item.hasOwnProperty("dataJson")
              ? JSON.parse(item.dataJson)
              : ""
          };

          history.actionNameLabel = this.buildActionLabel(history);

          histories.push(history);
        });

        h.each(this.comments, item => {
          histories.push(this.convertCommentToHistory(item));
        });

        histories.sort((item1, item2) =>
          item1.createTime > item2.createTime
            ? -1
            : item1.createTime < item2.createTime
            ? 1
            : 0
        );
      },

      classIconByActionName(actionName) {
        return actionName == "update"
          ? "fal fa-pencil-alt"
          : actionName == "insert"
            ? "fal fa-file-plus"
            : actionName == "chuyenXuLi"
              ? "far fa-arrow-alt-circle-right"
              : actionName == "banHanh"
                ? "fal fa-check-circle"
                : actionName == "tuChoi"
                  ? "fal fa-times-octagon"
                  : actionName == "tuChoiTiepNhan" || actionName == "lanhDaoTuChoi"
                    ? "fal fa-times-octagon"
                    : actionName == "choBanHanh"
                      ? "fal fa-clock"
                      : actionName == "kethuc"
                        ? "fal fa-calendar-check"
                        : actionName == "thuHoi"
                          ? "fal fa-undo"
                          : actionName == "thuHoiBanHanh"
                            ? "fas fa-reply-all"
                            : actionName == "chuyenXuLiDonVi"
                              ? "far fa-arrow-alt-circle-right"
                              : "";
      },

      classColorByActionName(actionName) {
        //mockup chuyen vien van thu tu choi
        // action.actionName = 'chuyenVienTuChoi'
        //   ? 'font-size__small color__red fal fa-reply'
        //   : ''
        return actionName === "update"
          ? "color__green"
          : actionName === "insert"
            ? "color__blue"
            : actionName === "chuyenXuLi"
              ? "color__cyan"
              : actionName === "banHanh"
                ? "color__blue"
                : actionName === "tuChoi"
                  ? "color__red"
                  : actionName === "tuChoiTiepNhan" || actionName === "lanhDaoTuChoi"
                    ? "color__red"
                    : actionName === "choBanHanh"
                      ? "color__blue"
                      : actionName === "kethuc"
                        ? "color__green"
                        : actionName === "thuHoi"
                          ? "color__yellow"
                          : actionName === "thuHoiBanHanh"
                            ? "color__blue"
                            : actionName === "chuyenXuLiDonVi"
                              ? "color__blue"
                              : "";
      }
    }
  };
</script>

<style scoped>
  .full-screen {
    animation: half-to-full 0.5s;
    transition: 0.5s;
    width: 100%;
  }

  .half-screen {
    width: 75%;
    max-width: 420px;
    transition: 0.5s;
  }

  .screen-30{
    animation: half-to-full 0.5s;
    transition: 0.5s;
    width: 50% !important;
  }

  .screen-50{
    animation: half-to-full 0.5s;
    transition: 0.5s;
    width: 70% !important;
  }

  .screen-70{
    animation: half-to-full 0.5s;
    transition: 0.5s;
    width: 100% !important;
  }

  .screen-100{
    animation: half-to-full 0.5s;
    transition: 0.5s;
    width: 130% !important;
  }

  @keyframes half-to-full {
    from {
      width: 75%;
    }
    to {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/History.vue